<p-fileUpload #fileUpload mode="basic" [styleClass]="styleClass" [chooseLabel]="chooseLabel" (onSelect)="onSelectBrowseFile($event.files)"
              [accept]="fileType" [auto]="true" [customUpload]="true" (uploadHandler)="handleUpload()"></p-fileUpload>
